import { Td, Tr } from '@chakra-ui/react'
import { Description } from './Description'
import { ViewScreenshot } from '../../../components/Feedback/ViewScreenshot'
import { VisualizarSolucao } from './VisualizarSolucao'
import { memo } from 'react'

export function ListComponent({ item }) {
  return (
    <Tr key={item.numero_chamado}>
      <Td>{item.solicitante}</Td>
      <Td>
        {item.data_abertura}
      </Td>
      <Td textAlign={'center'}>{item.tipo_chamado}</Td>
      <Td textAlign={'center'}>
        <Description
          item={item}
          description={item?.description}
          completeDescription={item?.detalhes_problema}
        />
      </Td>
      <Td>
        <ViewScreenshot screenshot={item.link_imagem} />
      </Td>
      {/* <Td textAlign={"center"}>{item.data_finalizado}</Td> */}
      <Td textAlign={'center'}>{item.responsavel}</Td>
      <Td textAlign={'center'}>
        <VisualizarSolucao solucao={item.resolucao_problema} />
      </Td>
    </Tr>
  )
}


export const List = memo(ListComponent, (prevProps, nextProps) => {
  return Object.is(prevProps.item, nextProps.item)
})